import { createPopper } from '@popperjs/core';

var placements = ['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end'];
var buildModifiers = function buildModifiers(offset, arrow, flip) {
  if (flip === void 0) {
    flip = false;
  }

  var modifiers = [{
    name: 'flip',
    enabled: flip,
    options: {
      boundary: 'viewport'
    }
  }, {
    name: 'preventOverflow',
    enabled: true,
    options: {
      padding: 0,
      boundariesElement: 'window'
    }
  }, {
    name: 'hide',
    enabled: false
  }, {
    name: 'computeStyle',
    options: {
      gpuAcceleration: false
    }
  }];

  if (arrow) {
    modifiers.push({
      name: 'arrow',
      options: {
        element: arrow
      }
    });
  }

  if (offset) {
    modifiers.push({
      name: 'offset',
      options: {
        offset: offset
      }
    });
  }

  return modifiers;
};

var position = function position(reference, target, placement, offset, arrow, flip) {
  return createPopper(reference, target, {
    placement: placement,
    modifiers: buildModifiers(offset, arrow, flip)
  });
};

export default position;
export { buildModifiers, placements };
